import { get, put } from './';

export const getCurrencyExchangeRates = () => get(`/currency-rates`);

export const modifyCurrencyExchangeRates = payload =>
  put(`/currency-rates`, payload);
